import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";
import FiltroReportes from "../Components/FiltroReportes";
import FiltroReportesCategoria from "../Components/FiltroReportesCategoria";

export const ReporteObjetivoTotal = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [clientes, setClientes] = useState([]);
    const [boxstate, setBoxState] = useBox();
    const [totalSaldo, setTotalSaldo] = useState(0);
    const [titulo, setTitulo] = useState("REPORTE DE OBJETIVO TOTAL DE CARTERA")

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // console.log(categoria)

    useEffect(() => {
        onExecute(state.ejercicio, state.periodo, state.tipo_grafica, state.tipo_cartera, state.estado_cartera, state.responsable_cobranza, state.categoria);
    }, []);

    const getEstadoNombre = (estadoCartera) => {
        const estados = {
            T: "TOTAL",
            R: "RECUPERADO",
            C: "CONVENIADO",
            P: "SIN GESTION",
        };

        return estados[estadoCartera] || "";
    };


    const onExecute = (ejercicio, periodo, tipo_grafica, tipo_cartera, estado_cartera, responsable, categoria) => {
        setLoader({ ...loader, mostrar: true });
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        return new Promise((resolve, reject) => {
            
            request
                .get(
                    `DashboardReportes/ReporteGraficaObjetivos?ejercicio=${ejercicio}&periodo=${periodo}&tipo_grafica=${state.tipo_grafica}&tipo_cartera=${state.tipo_cartera}&estado_cartera=${state.estado_cartera}&responsable_cobranza=${state.responsable}&categoria=${categoria}&adr=${adr}&sucursales=${sucursales}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setClientes(result);
                    calcularTotalSaldo(result);
                    setTitulo(`REPORTE DE OBJETIVO TOTAL DE CARTERA `+ (state.cartera === 'OPERACION' ? 'DE ' : '') + state.cartera + ' ' + getEstadoNombre(boxstate.categoria) || state.nombre )
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const calcularTotalSaldo = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.saldo) || 0), 0);
        setTotalSaldo(total);
    };

    //  console.log(state.cartera)

    return (
        <PlantillaScreen
            titulo={titulo}
            className_main={1}
            className={"reporte-total-cartera"}
        >
            <LoaderScreen loader={loader} />
            <div className="reporte-total-cartera-actions">
                <div
                    className="reporte-total-cartera-actions-regresar"
                    onClick={() => history.push('/Creditoycobranza/DashboardCobranza')}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="reporte-total-cartera-actions-filtro">
                    <FiltroReportesCategoria
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        estadoinicial={state.categoria}
                    />
                </div>
            </div>
            <div className="reporte-total-cartera-container scroll-4">
                <div className="reporte-total-cartera-header">
                    <div className="reporte-total-cartera-header-title">
                        <FormatListNumberedIcon /> Listado de Clientes
                    </div>
                    <div className="contador-convenios-encontrados">
                        Clientes Encontrados: {clientes.length}
                    </div>
                </div>
                <div className="reporte-total-cartera-container-table scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Sucursal</th>
                                <th>
                                    <div>Cliente</div>
                                </th>

                                <th>
                                    <div>Vencimiento</div>
                                </th>
                                <th>
                                    <div>Días Vencido</div>
                                </th>
                                <th>
                                    <div>Saldo</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((clt) => (
                                <tr>
                                    <td>{clt.sucursal}</td>
                                    <td>{clt.razon_social}</td>
                                    <td className="ta-center">{new Date(clt.vencimiento).toLocaleDateString()}</td>
                                    <td className="ta-center">{clt.dias_Vencido < 0 ? 0 : clt.dias_Vencido}</td>
                                    <td className="ta-right">{FormatMoney(clt.saldo, 2)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td className="ta-right" colSpan={3}></td>
                                <td className="ta-right">Total:</td>
                                <td className="ta-right">
                                    {FormatMoney(totalSaldo, 2)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </PlantillaScreen>
    );
};